module.exports = __webpack_public_path__ + "img/platform2.8bd6ead7.png";